import OfferListEventsContext, { OfferListEvents } from 'components/OfferList/v2/OfferListEventsContext'
import React, { useContext, useEffect, useRef } from 'react'
import { useInView } from 'react-intersection-observer'
import OfferCardDetail from './OfferCardDetail'
import { EventDataKey } from 'home/pages/HomePage/useHomepageAnalytics'
import useOffer from 'hooks/Offers/useOffer'

interface Props {
  id: string;
  idx?: number;
  className?: string;
  lazyLoad?: boolean;
  inViewThreshold?: number;
  inViewVerticalRootMargin?: string;
  analytics?: boolean;
}

export default function OfferCard(props: Props) {
  const { id, idx, lazyLoad, inViewThreshold, analytics, inViewVerticalRootMargin } = props
  const onEvent = useContext(OfferListEventsContext)
  const [inViewRef, inView] = useInView({ triggerOnce: true, threshold: 0.5 })
  const [loadInViewRef, loadInView] = useInView({ initialInView: false, threshold: inViewThreshold, rootMargin: inViewVerticalRootMargin })
  const [offer, isOfferFetching, offerError] = useOffer(id, { requireSummaryOnly: true, disabled: lazyLoad && !loadInView })
  const offerElementRef = useRef<HTMLDivElement>(null)
  // Since one ref is used for both useInView hooks
  // A new ref (tileElementRef) is created which sets the tileRef/rootRefs
  useEffect(() => {
    inViewRef(offerElementRef.current)
    loadInViewRef(offerElementRef.current)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offerElementRef.current])

  useEffect(() => {
    if (analytics && offer && !isOfferFetching && !offerError && inView) {
      const params = {
        offer,
        position: idx,
        key: EventDataKey.ProductImpression,
      }
      onEvent(OfferListEvents.impression, params)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView, offer, isOfferFetching, offerError, analytics])

  if (offerError) {
    return null
  }

  return (
    <div ref={offerElementRef}>
      <OfferCardDetail offer={offer} {...props} />
    </div>
  )
}
